import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

interface InteractionSignOffControls {
  doctorSigning: FormControl;
  dateAndTime: FormControl;
  signatureType: FormControl;
  drawnSignature: FormControl;
  typedSignature: FormControl;
  uploadedSignature: FormControl;
}

export class InteractionSignOffGroup extends FormGroup {
  controls: InteractionSignOffControls & { [key: string]: AbstractControl };
  submitted = false;

  constructor(values?: Partial<InteractionSignOffControls>) {
    super(
      {
        doctorSigning: new FormControl('', Validators.required),
        dateAndTime: new FormControl(),
        signatureType: new FormControl(null, Validators.required),
        drawnSignature: new FormControl(null),
        typedSignature: new FormControl(null),
        uploadedSignature: new FormControl(null)
      },
      { validators: InteractionSignOffGroup.signatureRequiredValidator }
    );

    if (values) {
      this.patchValue(values);
    }
  }

  private static signatureRequiredValidator: ValidatorFn = group => {
    const t = group.get('signatureType')!.value as 'drawn' | 'typed' | 'upload';
    const hasDrawn = !!group.get('drawnSignature')!.value;
    const hasTyped = !!group.get('typedSignature')!.value;
    const hasUpload = !!group.get('uploadedSignature')!.value;

    if (t === 'drawn' && hasDrawn) return null;
    if (t === 'typed' && hasTyped) return null;
    if (t === 'upload' && hasUpload) return null;
    return { signatureRequired: true };
  };
}
